
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/freight-templates/proforma-invoice",
      function () {
        return require("private-next-pages/resources/freight-templates/proforma-invoice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/freight-templates/proforma-invoice"])
      });
    }
  